import axios from "axios";
import { ApiResponse } from "@/types/api";
import { handleApiError } from "@/utils/formatApiError";

export type Optin = {
	uuid: string;
	service: OptinService;
	phone: boolean;
	email: boolean;
	sms: boolean;
	mail: boolean;
	createdAt: string;
	updatedAt: string;
};

export type OptinService = {
	uuid: string;
	name: string;
	description: string;
	createdAt: string;
	updatedAt: string;
};

export const createOptin = async ({
	...params
}): Promise<ApiResponse<Optin | null>> => {
	try {
		const response = await axios({
			url: `/api/optin`,
			method: "POST",
			data: { ...params },
		});

		return {
			data: response.data,
			error: null,
		};
	} catch (e: any) {
		return {
			data: null,
			error: handleApiError(e),
		};
	}
};
